(function () {
  document.querySelector('[data-sk-menu-toggle]')?.addEventListener('click', () => {
    const menu = document.querySelector('[data-sk-menu]');
    const btn = document.querySelector('[data-sk-menu-toggle]');
    if (!menu || !btn) return;
    const open = menu.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  const collectionRoot = document.querySelector('[data-sk-collection]');
  if (collectionRoot) {
    const revealTargets = collectionRoot.querySelectorAll('.sk-collection-hero__inner, .sk-collection-grid__head, .sk-collection-card');
    revealTargets.forEach((el, index) => {
      el.style.transition = 'opacity 1s ease, transform 1s ease';
      el.style.transitionDelay = `${Math.min(index * 0.05, 0.4)}s`;
      el.classList.add('sk-collection-reveal');
    });

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    revealTargets.forEach((el) => revealObserver.observe(el));
  }

  const root = document.querySelector('[data-sk-flagship-product]');
  if (!root) return;

  const imageZoom = root.dataset.imageZoom || 'hover';

  function initFlagshipZoom() {
    if (imageZoom !== 'hover') return;
    const img = root.querySelector('[data-sk-main-img].magnify-zoom');
    if (!img || typeof window.jQuery === 'undefined' || !window.jQuery.fn.magnify) return;

    const $img = window.jQuery(img);
    const $existing = $img.closest('.magnify');
    if ($existing.length) {
      $existing.find('.magnify-lens').remove();
      $img.insertAfter($existing);
      $existing.remove();
    }

    $img.magnify({
      magnifiedWidth: 1000,
      magnifiedHeight: 1000
    });
  }

  function scheduleZoomInit() {
    if (imageZoom !== 'hover') return;
    let attempts = 0;
    const tick = () => {
      attempts += 1;
      if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.magnify) {
        initFlagshipZoom();
        return;
      }
      if (attempts < 40) window.setTimeout(tick, 100);
    };
    tick();
  }

  const sticky = document.querySelector('.sk-flagship-sticky');
  const hero = document.querySelector('.sk-flagship-hero');
  if (sticky && hero) {
    const show = () => sticky.classList.toggle('is-visible', window.scrollY > 800);
    window.addEventListener('scroll', show, { passive: true });
    show();
  }

  const qtyVal = root.querySelector('[data-sk-qty-val]');
  const qtyMinus = root.querySelector('[data-sk-qty-minus]');
  const qtyPlus = root.querySelector('[data-sk-qty-plus]');
  const qtyInputs = () => root.querySelectorAll('[data-sk-qty-input]');

  if (qtyVal && qtyMinus && qtyPlus) {
    const setQty = (n) => {
      const v = Math.max(1, n);
      qtyVal.textContent = v;
      qtyInputs().forEach((el) => { el.value = v; });
    };
    qtyMinus.addEventListener('click', () => setQty(parseInt(qtyVal.textContent, 10) - 1));
    qtyPlus.addEventListener('click', () => setQty(parseInt(qtyVal.textContent, 10) + 1));
  }

  root.querySelector('[data-sk-sticky-add]')?.addEventListener('click', (event) => {
    event.preventDefault();
    const stickyAdd = event.currentTarget;
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const submitBtn = root.querySelector('.sk-flagship-hero__cta');
    if (!form || !submitBtn) return;
    if (
      stickyAdd.getAttribute('aria-disabled') === 'true' ||
      stickyAdd.disabled ||
      submitBtn.disabled ||
      submitBtn.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    stickyAdd.setAttribute('aria-disabled', 'true');
    stickyAdd.disabled = true;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    const unlockSticky = () => {
      stickyAdd.removeAttribute('aria-disabled');
      stickyAdd.disabled = false;
    };

    const observer = new MutationObserver(() => {
      if (submitBtn.getAttribute('aria-disabled') !== 'true' && !submitBtn.classList.contains('loading')) {
        unlockSticky();
        observer.disconnect();
      }
    });
    observer.observe(submitBtn, { attributes: true, attributeFilter: ['aria-disabled', 'class'] });
    window.setTimeout(() => {
      unlockSticky();
      observer.disconnect();
    }, 8000);
  });

  const mainImg = root.querySelector('[data-sk-main-img]');
  const zoomWrap = root.querySelector('[data-sk-zoom-wrap]');

  root.querySelectorAll('[data-sk-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const src = btn.dataset.skThumb;
      const zoomSrc = btn.dataset.skThumbZoom;
      if (!src || !mainImg) return;
      mainImg.src = src;
      if (zoomSrc && imageZoom === 'hover') {
        mainImg.setAttribute('data-magnify-src', zoomSrc);
        window.setTimeout(initFlagshipZoom, 50);
      }
      if (imageZoom === 'lightbox' && zoomWrap) {
        const link = zoomWrap.querySelector('a');
        if (link && zoomSrc) {
          link.href = zoomSrc;
          if (btn.dataset.skPswpWidth) link.dataset.pswpWidth = btn.dataset.skPswpWidth;
          if (btn.dataset.skPswpHeight) link.dataset.pswpHeight = btn.dataset.skPswpHeight;
        }
      }
      root.querySelectorAll('[data-sk-thumb]').forEach((t) => t.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  const detailsModal = root.querySelector('[data-sk-details-modal]');
  const detailsOpen = root.querySelector('[data-sk-details-open]');
  if (detailsModal && detailsOpen) {
    const closeDetails = () => detailsModal.close();
    detailsOpen.addEventListener('click', () => detailsModal.showModal());
    detailsModal.querySelectorAll('[data-sk-details-close]').forEach((btn) => {
      btn.addEventListener('click', closeDetails);
    });
    detailsModal.addEventListener('click', (event) => {
      const rect = detailsModal.getBoundingClientRect();
      const inside =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom;
      if (!inside) closeDetails();
    });
  }

  if (imageZoom === 'lightbox' && window.PhotoSwipeLightbox) {
    const lightbox = new PhotoSwipeLightbox({
      gallery: '[data-sk-zoom-wrap].pswp-gallery',
      children: 'a',
      pswpModule: PhotoSwipe
    });
    lightbox.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleZoomInit);
  } else {
    scheduleZoomInit();
  }
  window.addEventListener('load', scheduleZoomInit);
})();
